import { sendApiRequest, constructApiUrl } from '##/services/tenApi/apirequest';
import { config } from '##/services/store/store';
import { MarqueeData } from '##/components/HomeMarquee/types';
import { getProcessedLiveV2Response } from '##/utils';
import { SearchResponse, LiveV2Response } from './types';

export const getMarqueeData = async (): Promise<MarqueeData> => {
  const url = constructApiUrl('marquee');
  const marqueeData = await sendApiRequest<MarqueeData>(url);

  return {
    ...marqueeData,
    items:
      marqueeData?.items?.map((itemData, idx) => ({
        ...itemData,
        carouselTitle: marqueeData?.type?.toLowerCase(), // check
        carouselNumberOfItems: marqueeData.items.length,
        carouselVerticalIndex: 0,
        carouselType: marqueeData?.type?.toLowerCase(),
        carouselItemIndex: idx,
      })) || [],
  };
};

export const getLiveChannels = async (limit = 0): Promise<LiveV2Response> => {
  const { liveTvEndpoint } = config.$get().app;
  const { region } = config.$get().geo;

  const liveResponseFromApi = await sendApiRequest<LiveV2Response>(
    `${liveTvEndpoint}/${region}${limit ? `?limit=${limit}` : ''}`,
  );

  return getProcessedLiveV2Response(liveResponseFromApi);
};

export const getSearchResults = (term: string): Promise<SearchResponse> => {
  const { searchApiEndpoint } = config.$get().app;

  return sendApiRequest<SearchResponse>(searchApiEndpoint + term);
};
